<div
  class="table-heading-options"
  [ngClass]="{ 'table-heading-options--kpi-expanded': variant === 'kpi-expanded' }"
>
  <button
    type="button"
    class="group-btn"
    [ngClass]="{
      'group-btn--kpi-expanded': variant === 'kpi-expanded',
      'group-btn--kpi-expanded-active': variant === 'kpi-expanded' && totalGroupApplied > 0
    }"
    (click)="onToggle($event)"
  >
    <mat-icon
      *ngIf="variant === 'kpi-expanded'"
      svgIcon="list"
      class="group-btn-funnel-icon"
    ></mat-icon>
    <span>{{ isGrouped ? 'Group' : 'Group' }}</span>
    <span *ngIf="showBadge" class="group-btn-badge">{{ count }}</span>
    <span
      *ngIf="variant === 'kpi-expanded'"
      class="group-btn-chevron"
      [ngClass]="{ open: showMenu }"
    >
      <mat-icon svgIcon="caret-down" class="group-menu-chevron-icon"></mat-icon>
    </span>
  </button>

  <div *ngIf="showMenu" class="header-menu" (click)="onMenuClick($event)">
    <div class="header-menu-top">
      <div class="header-menu-top-actions">
        <span class="group-by-label">Group by</span>
      </div>
      <div class="header-menu-top-actions">
        <button
          type="button"
          [class.disabled]="isGroupApplied === false"
          (click)="toggleGrouping(false)"
        >
          Ungroup
        </button>
      </div>
    </div>

    <div class="header-menu-options" [class.active]="isGroupApplied === true">
      <div class="header-menu-options-actions">
        <button
          type="button"
          [class.active]="isGroupApplied === true"
          (click)="toggleGrouping(true)"
        >
          <span>Protocol number</span>
        </button>
      </div>
    </div>

    <div class="header-menu-footer">
      <div class="header-menu-footer-actions" id="one">
        <button type="button" [class.disabled]="isGroupApplied === false" (click)="onCollapseAll()">
          Collapse all
        </button>
      </div>
      <div class="header-menu-footer-actions" id="two">
        <button type="button" [class.disabled]="isGroupApplied === false" (click)="onExpandAll()">
          Expand all
        </button>
      </div>
    </div>
  </div>
</div>
